/*
 * Cushique — Smooth accordion animation for <details> elements
 * Uses the Web Animations API for buttery, frame-perfect open/close motion.
 * Targets any element with class .cq-acc on the page.
 */
(function () {
  'use strict';

  const OPEN_DURATION = 320;
  const CLOSE_DURATION = 260;
  // Cubic-bezier values for WAAPI easing
  const OPEN_EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';   // gentle ease-out
  const CLOSE_EASING = 'cubic-bezier(0.32, 0, 0.67, 0)';  // ease-in — decisive close

  function getContent(details) {
    return details.querySelector('.cq-acc__content');
  }

  function animateOpen(details) {
    const content = getContent(details);
    if (!content) return;

    if (details._cqAnim) {
      details._cqAnim.cancel();
    }

    const targetHeight = content.scrollHeight;
    content.style.overflow = 'hidden';

    const anim = content.animate(
      [
        { height: '0px', opacity: 0.6 },
        { height: targetHeight + 'px', opacity: 1 }
      ],
      {
        duration: OPEN_DURATION,
        easing: OPEN_EASING,
        fill: 'forwards'
      }
    );

    details._cqAnim = anim;

    anim.addEventListener('finish', () => {
      // Release back to natural sizing
      anim.cancel();
      content.style.overflow = '';
      details._cqAnim = null;
    });

    anim.addEventListener('cancel', () => {
      content.style.overflow = '';
      details._cqAnim = null;
    });
  }

  function animateClose(details, originalEvent) {
    const content = getContent(details);
    if (!content) return;

    // Don't allow the browser to snap-close
    originalEvent.preventDefault();

    if (details._cqAnim) {
      details._cqAnim.cancel();
    }

    const startHeight = content.scrollHeight;
    content.style.overflow = 'hidden';

    const anim = content.animate(
      [
        { height: startHeight + 'px', opacity: 1 },
        { height: '0px', opacity: 0.6 }
      ],
      {
        duration: CLOSE_DURATION,
        easing: CLOSE_EASING,
        fill: 'forwards'
      }
    );

    details._cqAnim = anim;

    anim.addEventListener('finish', () => {
      // Now actually close the <details>
      details.open = false;
      anim.cancel();
      content.style.overflow = '';
      details._cqAnim = null;
    });

    anim.addEventListener('cancel', () => {
      content.style.overflow = '';
      details._cqAnim = null;
    });
  }

  function bind(details) {
    if (details.dataset.cqBound === 'true') return;
    details.dataset.cqBound = 'true';

    const summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', (e) => {
      if (details.open) {
        animateClose(details, e);
      }
      // Opening is handled by the toggle listener below, which fires
      // after the browser sets details.open = true.
    });

    details.addEventListener('toggle', () => {
      if (details.open && !details._cqAnim) {
        animateOpen(details);
      }
    });
  }

  function init() {
    document.querySelectorAll('details.cq-acc').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => init());
  observer.observe(document.body, { childList: true, subtree: true });
})();
